import { Component, input, output } from '@angular/core';
import { MatSlideToggleChange, MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  imports: [MatSlideToggleModule, TranslateModule],
  selector: 'app-campaign-details-deliverables-group-toggle',
  templateUrl: './campaign-details-deliverables-group-toggle.component.html',
})
export class CampaignDetailsDeliverablesGroupToggleComponent {
  public readonly checked = input<boolean>(false);

  public readonly checkedChanged = output<boolean>();

  public onCheckedChange(event: MatSlideToggleChange): void {
    this.checkedChanged.emit(event.checked);
  }
}
